export const countryToCurrency = {
    US: 'USD',
    BR: 'BRL',
    CO: 'COP',
}

export const countryToCurrencySuffix = {
    US: '$',
    BR: 'R$',
    CO: '$',
}

export function getCurrencyByCountryCode(countryCode) {
    return countryToCurrency[countryCode.toUpperCase()];
}

export function getCurrencySuffixByCountryCode(countryCode) {
    return countryToCurrencySuffix[countryCode.toUpperCase()];
}